<section class="locations-panel">
  <header class="locations-panel__header">
    <div class="locations-panel__heading">
      <h2 class="locations-panel__title">Locations</h2>
      <p class="locations-panel__subtitle">
        The places your organization works from. Every team member is assigned
        to one or more of them.
      </p>
      <div class="locations-panel__stats" *ngIf="!isLoading && locations.length">
        <span class="locations-stat">
          <strong>{{ locations.length }}</strong>
          {{ locations.length === 1 ? "location" : "locations" }}
        </span>
        <span class="locations-stat locations-stat--active">
          <strong>{{ activeLocationsCount }}</strong> active
        </span>
        <span
          class="locations-stat locations-stat--inactive"
          *ngIf="disabledLocationsCount"
        >
          <strong>{{ disabledLocationsCount }}</strong> disabled
        </span>
      </div>
    </div>

    <div class="locations-panel__tools">
      <div class="locations-search" *ngIf="locations.length > 1">
        <i class="material-icons locations-search__icon">search</i>
        <input
          type="text"
          class="locations-search__input"
          placeholder="Search by name, city or country"
          aria-label="Search locations"
          [(ngModel)]="searchTerm"
        />
        <button
          type="button"
          class="locations-search__clear"
          *ngIf="searchTerm"
          (click)="clearSearch()"
          aria-label="Clear search"
        >
          <i class="material-icons">close</i>
        </button>
      </div>

      <button
        mat-flat-button
        color="primary"
        class="locations-panel__add"
        (click)="addLocation()"
      >
        <i class="material-icons">add_location_alt</i>
        <span>Add location</span>
      </button>
    </div>
  </header>

  <div class="locations-list" *ngIf="!isLoading">
    <article
      class="location-row"
      *ngFor="let location of filteredLocations; trackBy: trackByLocationId"
      [class.location-row--inactive]="!location.isActive"
    >
      <div class="location-row__identity">
        <div
          class="location-tile"
          [ngClass]="'location-tile--tone-' + tileTone(location)"
          aria-hidden="true"
        >
          <i class="material-icons">location_on</i>
        </div>
        <div class="location-identity">
          <p class="location-name">{{ location.name }}</p>
          <p class="location-meta">
            <ng-container *ngIf="regionLabel(location); else noRegion">
              <i class="material-icons location-meta__icon">public</i>
              {{ regionLabel(location) }}
            </ng-container>
            <ng-template #noRegion>
              <span class="location-meta__empty">No region set</span>
            </ng-template>
          </p>
        </div>
      </div>

      <div class="location-row__status">
        <span class="status-pill" [class.status-pill--active]="location.isActive">
          <span class="status-pill__dot"></span>
          {{ location.isActive ? "Active" : "Disabled" }}
        </span>

        <button
          mat-icon-button
          class="location-menu-trigger"
          [matMenuTriggerFor]="menu"
          aria-label="Location actions"
        >
          <i class="material-icons">more_vert</i>
        </button>
        <mat-menu #menu="matMenu" xPosition="before" class="location-menu">
          <button mat-menu-item (click)="editLocation(location)">
            <i class="material-icons" matMenuItemIcon>edit</i>
            <span>Edit</span>
          </button>
          <button mat-menu-item (click)="openToggleLocationActive(location)">
            <i class="material-icons" matMenuItemIcon>
              {{ location.isActive ? "block" : "check_circle_outline" }}
            </i>
            <span>{{ location.isActive ? "Disable" : "Enable" }}</span>
          </button>
          <button
            mat-menu-item
            class="qb-menu-danger"
            (click)="handleDeleteLocationModal(location.id)"
          >
            <i class="material-icons" matMenuItemIcon>delete_outline</i>
            <span>Delete</span>
          </button>
        </mat-menu>
      </div>
    </article>

    <div class="locations-empty" *ngIf="!locations.length">
      <i class="material-icons locations-empty__icon">add_location_alt</i>
      <p class="locations-empty__title">No locations yet</p>
      <p class="locations-empty__text">
        Add the places your team works from to start assigning members to them.
      </p>
      <button mat-flat-button color="primary" (click)="addLocation()">
        Add your first location
      </button>
    </div>

    <div class="locations-empty" *ngIf="locations.length && !filteredLocations.length">
      <i class="material-icons locations-empty__icon">search_off</i>
      <p class="locations-empty__title">No locations match “{{ searchTerm }}”</p>
      <p class="locations-empty__text">Try a different name, city or country.</p>
      <button type="button" class="locations-empty__link" (click)="clearSearch()">
        Clear search
      </button>
    </div>
  </div>

  <div class="locations-list locations-list--loading" *ngIf="isLoading" aria-busy="true">
    <div class="location-skeleton" *ngFor="let placeholder of skeletonRows">
      <div class="skeleton skeleton--tile"></div>
      <div class="location-skeleton__lines">
        <div class="skeleton skeleton--line skeleton--line-lg"></div>
        <div class="skeleton skeleton--line skeleton--line-sm"></div>
      </div>
      <div class="skeleton skeleton--pill"></div>
    </div>
  </div>
</section>
